export interface DashboardAdminYearResponse {
  query_income_year: number[];
  query_patients_speciality: number[];
  months_name: string[];
  query_patients_by_gender: {
    year: number;
    month: number;
    hombre: string;
    mujer: string;
  }[];
}
